import React, { useContext, useEffect, useState } from 'react'
import {
  Form,
  Grid,
  GridRow,
  GridColumn,
  FormField,
  Button,
} from 'semantic-ui-react'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import { CustomerViewContext } from '../customer-info-view/customerView'
import {
  updateCustomerSettings,
  getCustomerSettings,
} from '../../../../services/customer'
import styles from './customerSettings.module.css'

const formValidator = {
  inactivityTimeout: yup.string().required('Inactivity Threshold is required'),
}

const InactivitySettings = () => {
  const product = localStorage.getItem('product')
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  useEffect(() => {
    ;(async () => {
      Swal.showLoading()
      try {
        const queryParams = {
          product,
          id: customerSettings.tbCustomerId,
        }
        const res = await getCustomerSettings(queryParams)
        const attribute = res.data
          .filter((attr) => attr.id.attributeKey === 'inactiveThresholdPerMins')
          .pop()
        setThreshold(attribute.longValue / 60 / 24)
        Swal.close()
      } catch (e) {
        Swal.fire('Error Getting Customer Settings', '', 'error')
      }
    })()
  }, [])

  // eslint-disable-next-line no-unused-vars
  const { customerSettings, setViewNetworkSettings } =
    useContext(CustomerViewContext)

  const saveInactivitySettings = async (data) => {
    // eslint-disable-next-line no-param-reassign
    data.inactivityTimeout = data.inactivityTimeout * 24 * 60 // inactivity timeout in minutes
    const queryParams = {
      product,
      id: customerSettings.tbCustomerId,
    }

    Swal.showLoading()
    try {
      await updateCustomerSettings(queryParams, data)
      await Swal.fire({
        title: 'Inactivity Settings Updated Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setViewNetworkSettings(false)
    } catch (e) {
      Swal.fire('Something Went Wrong', '', 'error')
    }
  }

  const [threshold, setThreshold] = useState(2)

  return (
    <>
      <>
        <Form
          style={{
            backgroundColor: 'rgb(216, 231, 234)',
            padding: 10,
            borderRadius: 9,
          }}
          onSubmit={handleSubmit(saveInactivitySettings)}
        >
          <FormField>
            <Grid columns={3}>
              <GridRow>
                <GridColumn>
                  <FormField>
                    <span>Inactivity Threshold (days):</span>
                    <input
                      min={0}
                      name="inactivityTimeout"
                      placeholder="..."
                      type="number"
                      ref={register}
                      value={threshold}
                      onChange={(e) => {
                        setThreshold(e.target.value)
                      }}
                    />
                    <small style={{ color: 'red' }}>**</small>
                    {errors.inactivityTimeout && (
                      <p style={{ color: 'red' }}>
                        {errors.inactivityTimeout.message}
                      </p>
                    )}
                  </FormField>
                </GridColumn>
              </GridRow>
            </Grid>
            <hr />
            <Grid>
              <Grid.Column textAlign="center">
                <Button
                  from="config form"
                  type="submit"
                  className={styles.button}
                  style={{ backgroundColor: '#5cb85c', color: '#FFF' }}
                >
                  Save
                </Button>
              </Grid.Column>
            </Grid>
          </FormField>
        </Form>
      </>
    </>
  )
}

export default InactivitySettings
